import { message } from "skin/event";
import { status } from "skin/event/status";

const fn = (data) => {
	const fld = data.curData.values.fld;
	for (const key in fld) {
		if (["code", "name", "txtVal"].includes(key) && !fld[key]) {
			message(["Должны быть заполнены следующие поля:", "Код, Триггер и Тип"], "Внимание");
			return status.ignore;
		}
	}
	return status.action;
};

// Для воронки продаж проверяем заполнение полей перед созданием
const msFunnel = (obj, ms, story, data, d, action) => {
	if (obj.action === "next") return fn(data);
	return status.action;
};

export default msFunnel;
